/**
 * @module Registration
 */
(function Registration() {

    function practicalSeminars(dom) {
        var _this = this;

        this.wrapper = '[data-js="practical-seminars"]';
        this.checkbox = '[data-seminar="checkbox"]';
        this.infoText = '[data-seminar="info-text"]';
        this.required = '[data-seminar="required"]';
        var checkboxWrapper = $(dom).find(_this.wrapper);
        var limit = 2;
        var showInfoTextLimit = 1;

        this.observe = function () {

            _this.getCheckboxes().on('change', function () {
                _this.observeAction(this);
            });

            // inital required
            _this.setRequired();
        };

        this.observeAction = function (element) {
            // update wrapper due cloning incompatible
            _this.setWrapper(element);

            var checked = _this.getCheckboxes().filter(':checked').length;
            // prevent check more then "limit" checkboxes
            if (checked > limit) {
                $(element)[0].checked = false;
            }
            else if (checked <= showInfoTextLimit) {
                _this.getInfobox().addClass('visible');
            }
            else {
                _this.getInfobox().removeClass('visible');
            }

            _this.setRequired();
        };

        this.setRequired = function () {
            var checked = _this.getCheckboxes().filter(':checked').length;
            if (checked == 0) {
                _this.getRequired().attr('required', 'required');
            } else {
                _this.getRequired().removeAttr('required');
            }
        };

        this.getRequired = function () {
            return $(checkboxWrapper).find(_this.required);
        };

        this.getCheckboxes = function () {
            return $(checkboxWrapper).find(_this.checkbox);
        };

        this.getInfobox = function () {
            return $(checkboxWrapper).find(_this.infoText);
        };

        this.setWrapper = function (element) {
            checkboxWrapper =  $(element).closest(_this.wrapper)[0];
        };

        _this.observe();
    }

    // default dom.ready listener, features are not needed in neos backend
    $(document).ready(function () {

        // default multiplicity rendering
        $('[data-tdform-multiplicity="participantsContainer"]').each(function (idx, element) {
            var multiplicity = new TechDivisionForm.Multiplicity($(element), {
                specialElementRendering: function (prototypeElement, number) {
                    practicalSeminars(prototypeElement);

                    var $hotelWrapper = prototypeElement.find('[data-event-hotel="wrapper"]');

                    // Set current number of Participant
                    prototypeElement.find('[data-header="count"]').html(number);

                    var $hotelPrototype = $hotelWrapper.find('[data-event-hotel="element"]').clone();
                    $hotelWrapper.find('[data-event-hotel="element"]').remove();

                    var addButton = $hotelWrapper.find('[data-event-hotel="add"]');
                    var removeButton = $hotelWrapper.find('[data-event-hotel="remove"]');
                    removeButton.hide();

                    var proceeding = false;

                    removeButton.click(function () {
                        if (proceeding) return;
                        proceeding = true;
                        var removeElement = $hotelWrapper.find('[data-event-hotel="element"]');
                        removeElement.slideUp(400, function () {
                            removeElement.remove();
                        });
                        removeButton.hide();
                        addButton.slideDown(400, function () {
                            proceeding = false;
                        });
                    });

                    addButton.click(function () {
                        if (proceeding) return;
                        proceeding = true;
                        addButton.hide();
                        removeButton.slideDown();
                        var $newHotel = $hotelPrototype.clone();
                        $newHotel.hide();

                        $hotelWrapper.append($newHotel);

                        var hotelContainers = $newHotel.find('[data-event-hotel="container"]');
                        hotelContainers.hide();
                        hotelContainers.first().show();
                        hotelContainers.first().find('input[type="radio"]').first().prop('checked', true);
                        $newHotel.find('[data-event-hotel-action="select"]').change(function () {
                            var hotelIdentifier = $(this).val();
                            hotelContainers.hide();
                            hotelContainers.find('input[type="radio"]').prop('checked', false);

                            var hotelContainer = $newHotel.find('[data-event-hotel-identifier="' + hotelIdentifier + '"]');
                            hotelContainer.find('input[type="radio"]').first().prop('checked', true);
                            hotelContainer.show();
                        });

                        if (window.moment) {
                            moment.locale($('html').attr('lang'))
                        }
                        $newHotel.find('.datepicker').daterangepicker({
                            "autoApply": true,
                            "showCustomRangeLabel": false,
                            "startDate": $newHotel.find('.datepicker').data('start'),
                            "endDate": $newHotel.find('.datepicker').data('end'),
                            "minDate": $newHotel.find('.datepicker').data('min'),
                            "maxDate": $newHotel.find('.datepicker').data('max'),
                            "opens": "center",

                            // override existing template:
                            "template":
                            '<div class="daterangepicker dropdown-menu">' +
                            '<div class="calendar left">' +
                            '<div class="daterangepicker_header">' +
                            '<p>' + $newHotel.find('.datepicker').data('arrive-label') + '</p>' +
                            '</div>' +
                            '<div class="daterangepicker_input">' +
                            '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
                            '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                            '<div class="calendar-time">' +
                            '<div></div>' +
                            '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                            '</div>' +
                            '</div>' +
                            '<div class="calendar-table"></div>' +
                            '</div>' +
                            '<div class="calendar right">' +
                            '<div class="daterangepicker_header">' +
                            '<p>' + $newHotel.find('.datepicker').data('departure-label') + '</p>' +
                            '</div>' +
                            '<div class="daterangepicker_input">' +
                            '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
                            '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                            '<div class="calendar-time">' +
                            '<div></div>' +
                            '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                            '</div>' +
                            '</div>' +
                            '<div class="calendar-table"></div>' +
                            '</div>' +
                            '<div class="ranges">' +
                            '<div class="range_inputs">' +
                            '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                            '<button class="cancelBtn" type="button"></button>' +
                            '</div>' +
                            '</div>' +
                            '</div>'
                        });
                        if($newHotel.find('.datepicker').data('initialempty')) {
                            $newHotel.find('.datepicker').val('');
                        }
                        $newHotel.slideDown(400, function () {
                            proceeding = false;
                        });
                    });
                }
            });
        });
    });
})();



